import React from "react";

const SpaInJakkurCustomer = () => {
  return (
    <div className="hairSalonInJakkurCustomer">
      <h5>Client Experiences at Our Spa in Jakkur</h5>
      <p>
        Our clients often share their positive experiences after visiting our
        Spa in Jakkur. Here are a few testimonials:
      </p>
      <div className="hairSalonInJakkurCustomerContent">
        <p>
          <span className="quote">“</span>My visit to SCENT’s Spa in Jakkur was
          absolutely amazing. The ambiance was serene, and the massage I
          received was perfect. The therapists were professional and attentive,
          making my experience truly relaxing. I highly recommend this spa for
          anyone looking to unwind.<span className="quote">”</span> -{" "}
          <span>Ananya P. </span>
        </p>
        <p>
          <span className="quote">“</span>I had a fantastic facial at the Spa in
          Jakkur. The products used were top-notch, and my skin felt rejuvenated
          and refreshed. The staff was friendly and knowledgeable, making the
          entire visit a pleasure. I’ll definitely be returning for more
          treatments.
          <span className="quote">”</span> - <span>– Ramesh K. </span>
        </p>
      </div>
    </div>
  );
};

export default SpaInJakkurCustomer;
